import React from 'react';
import { Header } from './components/Header';
import { Statement } from './components/Statement';
import { Coaching } from './components/Coaching';
import { ForParents } from './components/ForParents';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-pearl-50 font-sans transition-colors duration-300 dark:bg-slate-950" data-id="element-0" data-mp="3f8nfjlvnpha5">
      <Header data-id="element-1" data-mp="2mlu68f47b9oj" />
      <main data-id="element-2" data-mp="2mmcbu2cr7094">
        <Statement data-id="element-3" data-mp="2mmvl6uoc8gbj" />
        <Coaching data-id="element-4" data-mp="2mndpmel5m0uj" />
        <Pricing data-id="element-5" data-mp="2mjpwhgjmfggc" />
        <ForParents data-id="element-6" data-mp="31aqfuglwour9" />
        <Faq data-id="element-7" data-mp="31b8lg3ugklbu" />
      </main>
      <Footer data-id="element-8" data-mp="31bi9vmzuukff" />
    </div>;
}